import { Icon } from "leaflet";
import React, { useEffect } from "react";
import {
	MapContainer,
	Marker,
	Polygon,
	TileLayer,
	useMap,
} from "react-leaflet";
import PopupBodyItem from "../../Helpers/Popup/PopupParts/PopupBodyItem";
import trans from "../../../utils";
import L from "leaflet";

export default function POIsSetupLocation({ poidetails }) {
	Icon.Default.mergeOptions({
		iconUrl: "https://www.svgrepo.com/show/513317/location-pin.svg",
	});
	function capitalizeWords(str) {
		if (!str) return "";
		return str
			.split(" ")
			.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
			.join(" ");
	}
	function FlyToGeo({ area, diameter }) {
		const map = useMap();

		useEffect(() => {
			if (!area) return;

			// Parse WKT polygon
			const coordsString = area.replace("POLYGON ((", "").replace("))", "");

			const coords = coordsString.split(",").map((pair) => {
				const [lat, lng] = pair.trim().split(" ").map(Number);
				return [lat, lng];
			});

			// Compute polygon bounds
			const bounds = L.latLngBounds(coords);
			const center = bounds.getCenter();

			// Compute zoom level based on diameter
			// Smaller diameter -> larger zoom
			// Clamp between 12 and 20 for safety
			const zoom = 20 - Math.log2(diameter / 50); // adjust scaling
			const clampedZoom = Math.min(20, Math.max(12, zoom));

			// Fly to polygon center
			map.flyTo(center, clampedZoom, { duration: 1.5 });
		}, [area, diameter, map]);

		return null;
	}
	const polygonCoords = poidetails?.area
		? poidetails.area
				.replace("POLYGON ((", "")
				.replace("))", "")
				.split(",")
				.map((pair) => {
					const [lat, lng] = pair.trim().split(" ").map(Number);
					return [lat, lng]; // keep [lat, lng] for Leaflet
				})
		: null;

	return (
		<div>
			<p className="fs-16 fw-500 brand-700 text-uppercase">
				{trans("Location Details")}
			</p>
			<div className="row">
				<div className="col-lg-12">
					<div className="display-border">
						<PopupBodyItem
							title={trans("Country")}
							item={trans(capitalizeWords(poidetails?.country))}
						/>
						<PopupBodyItem
							title={trans("City")}
							item={trans(capitalizeWords(poidetails?.city))}
						/>
						<PopupBodyItem
							title={trans("State")}
							item={trans(capitalizeWords(poidetails?.state))}
						/>
						<PopupBodyItem
							title={trans("poi latitude")}
							item={poidetails?.latitude}
						/>
						<PopupBodyItem
							title={trans("poi longitude")}
							item={poidetails?.longitude}
						/>
						<PopupBodyItem
							title={trans("Geofenced")}
							item={poidetails?.geofenced ? trans("ON") : trans("OFF")}
						/>
					</div>
				</div>
			</div>
			<MapContainer
				className="mt-2"
				center={[poidetails?.latitude, poidetails?.longitude]} // Update center when position changes
				zoom={20}
				style={{ height: "300px", width: "100%", borderRadius: "8px" }}
			>
				<FlyToGeo area={poidetails?.area} diameter={poidetails?.diameter} />
				{poidetails.geofenced && polygonCoords && (
					<Polygon
						positions={polygonCoords}
						pathOptions={{ color: "#2E9245", fillOpacity: 0.2 }}
					/>
				)}
				<TileLayer url="https://mt0.google.com/vt/lyrs=m&x={x}&y={y}&z={z}" />
				<Marker position={[poidetails?.latitude, poidetails?.longitude]} />
			</MapContainer>
			<p style={{ color: "#2E9245" }}>
				{" "}
				{poidetails?.address && poidetails?.address}
			</p>
		</div>
	);
}
